import { Action } from '@ngrx/store';

export enum EAgentActions {
    GetAllAgents = '[Agents] Get All Agents',
    GetAllAgentsSuccess = '[Agents] Set All Agents Success',
    GetAllAgentsError = '[] Set All Agents Error',
    AddAgent = '[Agents] Add Agents',
    GetAddAgentSuccess = '[Agents] Set Add Agents Success',
    GetAddAgentError = '[] Set Add Agents Error',
    ImportAgent = '[Agents] Import Agents',
    GetImportAgentSuccess = '[Agents] Set Import Agents Success',
    GetImportAgentError = '[] Set Import Agents Error',
    EditAgent = '[Agents] Edit Agents',
    GetEditAgentSuccess = '[Agents] Set Edit Agents Success',
    GetEditAgentError = '[] Set Edit Agents Error',
    DownloadFile = '[Agents] Download File',
    DownloadFileByUrl = '[Agents] Download File By URL',
    DownloadFileByUrlSuccess = '[Agents] Download File By URL Success',
    DownloadFileByUrlError = '[Agents] Download File By URL Error',
    GetDownloadFileSuccess = '[Agents] Get Download File Success',
    GetDownloadFileError = '[] Get Download File Error',
    AgentInactivestatus = '[Agents] Get Agent InActive',
    GetAgentInactiveSuccess = '[Agents] Get Agent InActive Success',
    GetAgentInactiveError = '[Agents] Get Agent InActive Error',
    Agentactivestatus = '[Agents] Get Agent Active',
    GetAgentactiveSuccess = '[Agents] Get Agent Active Success',
    GetAgentactiveError = '[Agents] Get Agent Active Error',
    GetAgentsBystatusId = '[Agents]  Get Agents By statusId',
    GetAgentsBystatusIdSuccess = '[Agents] Get Agents By statusId Success',
    GetAgentsBystatusIdError = '[Agents] Get Agents By statusId Error'
}

export class GetAllAgents implements Action {
    public readonly type = EAgentActions.GetAllAgents;
    constructor(public payload: any) {}
}

export class GetAllAgentsSuccess implements Action {
    public readonly type = EAgentActions.GetAllAgentsSuccess;
    constructor(public payload: any) {}
}

export class GetAllAgentsError implements Action {
    public readonly type = EAgentActions.GetAllAgentsError;
    constructor(public payload: any) {}
}

export class AddAgent implements Action {
    public readonly type = EAgentActions.AddAgent;
    constructor(public payload: any) {}
}

export class GetAddAgentSuccess implements Action {
    public readonly type = EAgentActions.GetAddAgentSuccess;
    constructor(public payload: any) {}
}

export class GetAddAgentError implements Action {
    public readonly type = EAgentActions.GetAddAgentError;
    constructor(public payload: any) {}
}

export class ImportAgent implements Action {
    public readonly type = EAgentActions.ImportAgent;
    constructor(public payload: any) {}
}

export class GetImportAgentSuccess implements Action {
    public readonly type = EAgentActions.GetImportAgentSuccess;
    constructor(public payload: any) {}
}

export class GetImportAgentError implements Action {
    public readonly type = EAgentActions.GetImportAgentError;
    constructor(public payload: any) {}
}

export class EditAgent implements Action {
    public readonly type = EAgentActions.EditAgent;
    constructor(public payload: any, public param: any) {
        // console.log(param)
    }
}

export class GetEditAgentSuccess implements Action {
    public readonly type = EAgentActions.GetEditAgentSuccess;
    constructor(public payload: any) {}
}

export class GetEditAgentError implements Action {
    public readonly type = EAgentActions.GetEditAgentError;
    constructor(public payload: any) {}
}

export class DownloadFile implements Action {
    public readonly type = EAgentActions.DownloadFile;
    constructor(public payload: any) {
    }

}

export class DownloadFileByUrl implements Action {
  public readonly type = EAgentActions.DownloadFileByUrl;
  constructor(public payload: any) {}
}

export class GetDownloadFileSuccess implements Action {
    public readonly type = EAgentActions.GetDownloadFileSuccess;
    constructor(public payload: any) {
    }
}

export class GetDownloadFileError implements Action {
    public readonly type = EAgentActions.GetDownloadFileError;
    constructor(public payload: any) {}
}
export class AgentInactivestatus implements Action {
    public readonly type = EAgentActions.AgentInactivestatus;
    constructor(public payload: any,public param: any) {}
}
export class GetAgentInactiveSuccess implements Action {
    public readonly type = EAgentActions.GetAgentInactiveSuccess;
    constructor(public payload: any) {}
}
export class GetAgentInactiveError implements Action {
    public readonly type = EAgentActions.GetAgentInactiveError;
    constructor(public payload: any) {}
}
export class Agentactivestatus implements Action {
    public readonly type = EAgentActions.Agentactivestatus;
    constructor(public payload: any,public param: any) {}
}
export class GetAgentactiveSuccess implements Action {
    public readonly type = EAgentActions.GetAgentactiveSuccess;
    constructor(public payload: any) {}
}
export class GetAgentactiveError implements Action {
    public readonly type = EAgentActions.GetAgentactiveError;
    constructor(public payload: any) {}
}
export class GetAgentsBystatusId implements Action {
    public readonly type = EAgentActions.GetAgentsBystatusId;
    constructor(public payload: any) {}
}
export class GetAgentsBystatusIdSuccess implements Action {
    public readonly type = EAgentActions.GetAgentsBystatusIdSuccess;
    constructor(public payload: any) {}
}
export class GetAgentsBystatusIdError implements Action {
    public readonly type = EAgentActions.GetAgentsBystatusIdError;
    constructor(public payload: any) {}
}
export type AgentAction =   GetAllAgents | GetAllAgentsSuccess | GetAllAgentsError |
                            AddAgent | GetAddAgentSuccess | GetAddAgentError |
                            ImportAgent | GetImportAgentSuccess | GetImportAgentError |
                            EditAgent | GetEditAgentSuccess | GetEditAgentError |
                            DownloadFile | GetDownloadFileSuccess | GetDownloadFileError|
                            AgentInactivestatus|GetAgentInactiveSuccess|GetAgentInactiveError|
                            Agentactivestatus|GetAgentactiveSuccess|GetAgentactiveError |
                            GetAgentsBystatusId| GetAgentsBystatusIdSuccess| GetAgentsBystatusIdError;